import SimpleStageCard from './SimpleStageCard';

export default SimpleStageCard;
